export default {
  welcome: "Bienvenue",
}
